<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CWrapper class="justify-content-between">
      <div>
        <main class="justify-content-between position-relative">
          <CContainer>
            <CWrapper class="justify-content-between">
              <ToastMessage />
              <router-view :key="$route.path"></router-view>
            </CWrapper>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import ToastMessage from '@/components/ToastMessage'

export default {
  name: 'TheContainer',
  components: {
    ToastMessage,
  },
  created() {
    //TODO melhorar evitar que se tenha que enviar isso para zerar o setToastMessage
    this.$store.commit('setToastMessage', null)
  },
}
</script>

<style></style>
